import React, { useState, useEffect } from 'react';
import { Search, Loader2, Download, Check, X, FileText } from 'lucide-react';

export default function AdminReports() {
  const [reports, setReports] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => { fetchReports(); }, []);

  const fetchReports = async () => {
    try {
      const token = localStorage.getItem('admin_token');
      const response = await fetch('/api/admin/reports', { headers: { 'Authorization': `Bearer ${token}` } });
      if (response.ok) setReports(await response.json());
    } catch (err) { console.error(err); } finally { setIsLoading(false); }
  };

  const handleAction = async (testerId, sessionId, action) => {
    const isApprove = action === 'approve';
    if (!window.confirm(`Möchten Sie diesen Report wirklich ${isApprove ? 'akzeptieren und das Geld auszahlen' : 'ablehnen'}?`)) return;

    try {
      const token = localStorage.getItem('admin_token');
      const response = await fetch(`/api/admin/reports/${action}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ tester_id: testerId, session_id: sessionId })
      });
      if (response.ok) {
        setReports(prev => prev.filter(r => !(r.tester_id === testerId && r.session_id === sessionId)));
      }
    } catch (err) { console.error(err); }
  };

  // NEU: Echter Datei-Download statt HTML-Weiterleitung
  const forceDownload = async (fileUrl, userName, sessionTitle) => {
    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      const extension = fileUrl.split('.').pop() || 'pdf';
      link.setAttribute('download', `Report_${userName.replace(/\s+/g, '_')}_${sessionTitle.replace(/\s+/g, '_')}.${extension}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Fehler beim Herunterladen:", error);
      alert("Fehler beim Herunterladen der Datei.");
    }
  };

  return (
    <div className="animate-in fade-in slide-in-from-bottom-4 relative">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-primary">Report-Prüfungen</h1>
        <p className="text-muted-foreground">Prüfen Sie eingereichte Testergebnisse und geben Sie Provisionen frei.</p>
      </div>

      <div className="bg-white rounded-xl border border-border shadow-sm overflow-hidden w-full">
        {isLoading ? (
          <div className="flex flex-col items-center justify-center h-64 text-secondary"><Loader2 className="w-8 h-8 animate-spin mb-4 text-accent" /></div>
        ) : reports.length === 0 ? (
          <div className="flex items-center justify-center h-64 text-muted-foreground">Keine offenen Reports zur Prüfung vorhanden.</div>
        ) : (
          <div className="overflow-x-auto w-full">
            <table className="w-full text-left border-collapse min-w-[800px]">
              <thead>
                <tr className="bg-slate-50 border-b border-border text-sm text-secondary">
                  <th className="p-4 font-semibold">Tester</th>
                  <th className="p-4 font-semibold">Auftrag (Test-Session)</th>
                  <th className="p-4 font-semibold">Dokument</th>
                  <th className="p-4 font-semibold">Auszahlung</th>
                  <th className="p-4 font-semibold text-right">Entscheidung</th>
                </tr>
              </thead>
              <tbody>
                {reports.map((item, idx) => (
                  <tr key={idx} className="border-b border-border hover:bg-slate-50/50">
                    <td className="p-4"><p className="font-medium text-primary">{item.tester_name}</p><p className="text-xs text-muted-foreground font-mono">{item.tester_id}</p></td>
                    <td className="p-4"><p className="font-medium text-primary">{item.session_title}</p><p className="text-xs text-muted-foreground">{item.session_id}</p></td>
                    <td className="p-4">
                      {/* Hier rufen wir jetzt die neue Blob-Funktion auf */}
                      <button onClick={() => forceDownload(item.report_url, item.tester_name, item.session_title)} className="flex items-center gap-2 text-accent hover:underline text-sm font-medium">
                        <FileText className="w-4 h-4" /> Download Report
                      </button>
                      <span className="text-xs text-slate-400 mt-1 block">Vom: {item.submitted_at}</span>
                    </td>
                    <td className="p-4 font-bold text-green-600">{item.reward}</td>
                    <td className="p-4 text-right">
                      <div className="flex justify-end gap-2">
                        <button onClick={() => handleAction(item.tester_id, item.session_id, 'reject')} className="px-4 py-2 text-red-600 bg-white border border-red-200 hover:bg-red-50 rounded-md font-medium text-sm">Ablehnen</button>
                        <button onClick={() => handleAction(item.tester_id, item.session_id, 'approve')} className="px-4 py-2 text-white bg-green-600 hover:bg-green-700 rounded-md font-medium text-sm flex items-center gap-1"><Check className="w-4 h-4"/> Freigeben</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}